<template>
    <Navbar/>
    <Blog3Body/>
    <Footer/>
  </template>
  
  <script>
  import { defineComponent } from "vue";
  import Navbar from "@/components/NavbarBody.vue";
  import Blog3Body from "@/components/blog/Blog3Body.vue";
  import Footer from "@/components/FooterBody.vue"; 
  
  export default defineComponent({
    name: "Blog3View",
    components: {
      Navbar,
      Blog3Body,
      Footer
    },
  });
  </script>
  